import { employeesRole } from "./employees-role";

export const teamAndRoles = {
	employeesRole,
};
